import React, { Component } from 'react';
import { Form, Select, Button } from 'antd';

const { Option } = Select;

class Search extends Component {

  componentDidMount() {
    if (typeof this.props.onRef === 'function') this.props.onRef(this);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.fn(this.props.form);
  };

  handleReset = () => {
    this.props.form.resetFields();
    this.props.fnReset();
  };

  clearTxtSearch = () => {
    this.props.form.resetFields();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { countryList } = this.props;

    return (
      <Form className="ant-advanced-search-form" layout="inline" onSubmit={this.handleSubmit}>
        <Form.Item>
          {getFieldDecorator('country_abbr', {
            rules: [{ required: false }],
          })(
            <Select
              showSearch
              placeholder="Select Country"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: '200px' }}
            >
              {(countryList || []).map((item, i) => (
                <Option key={i} value={item.region_code}>
                  {item.name}
                </Option>
              ))}
            </Select>,
          )}
        </Form.Item>
        <Form.Item>
          <Button.Group>
            <Button htmlType="submit" icon="search" />
            <Button icon="redo" onClick={this.handleReset} />
          </Button.Group>
        </Form.Item>
      </Form>
    );
  }
}


const SearchForm = Form.create({ name: 'search-frm' })(Search);

export default SearchForm;



// WEBPACK FOOTER //
// ./src/containers/GatewayCountry/search-form.js